import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import { TextField, Autocomplete } from "@mui/material";
import { handleSubmitNewSureviewAlert } from "./EditCameraUtils/handleSubmitNewSureviewAlert";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import FormLabel from "@mui/material/FormLabel";

export const AddSureviewAlertDialog = ({
  setAddSureviewAlertDialogOpen,
  addSureviewAlertDialogOpen,
  sureViewAlerts,
  setBackdropLoadingScreenOn,
  setCameraGeneralInfo,
  setCameraGeneralInfoBackup,
  setGeneralInfoChangesMade,
  setPatchObject,
  setSureviewAlerts,
  setActiveTab,
  cameraGeneralInfoBackup,
  setIgnoreZonesBreadCrumbs,
  handleSitesBreadcrumbClick,
  handleSingularSiteBreadcrumbClick,
  cameraGeneralInfo,
  immixAlerts,
  setAddImmixAlertDialogOpen,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  setDeleteImmixAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  immixAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
}: {
  setAddSureviewAlertDialogOpen: any;
  addSureviewAlertDialogOpen: any;
  sureViewAlerts: any;
  setBackdropLoadingScreenOn: any;
  setCameraGeneralInfo: any;
  setCameraGeneralInfoBackup: any;
  setGeneralInfoChangesMade: any;
  setPatchObject: any;
  setSureviewAlerts: any;
  setActiveTab: any;
  cameraGeneralInfoBackup: any;
  setIgnoreZonesBreadCrumbs: any;
  handleSitesBreadcrumbClick: any;
  handleSingularSiteBreadcrumbClick: any;
  cameraGeneralInfo: any;
  immixAlerts: any;
  setAddImmixAlertDialogOpen: any;
  setSendingImmixTest: Dispatcher<boolean>;
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>;
  setImmixTestFailDialogOpen: Dispatcher<boolean>;
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: Dispatcher<boolean>;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>;
  immixAlertsOnCamera: any;
  sureViewAlertsOnCamera: any;
  siteInfo: any;
  webhooksAlertsOnCamera: any;
  sentinelAlertsOnCamera: any;
  boldAlertsOnCamera: any;
  patriotAlertsOnCamera: any;
  softguardAlertsOnCamera: any;
  evalinkAlertsOnCamera: boolean;
}) => {
  const { cameraStreams, cameraStreamsPatchObject } = useEditCameraStore();

  const streamNames = new Map();
  cameraStreams?.forEach((object: any, index: number) => {
    streamNames.set(`${object.name} (${object.product})`, index);
  });

  const navigate = useNavigate();

  const serverOptions = [
    ["US SMTP Server", "us-smtp.sureviewops.com"],
    ["EU SMTP Server", "eu-smtp.sureviewops.com"],
  ];

  const optionsIds = new Map();
  const optionNames = new Map();
  serverOptions.forEach((option: any) => {
    optionsIds.set(option[0], option[1]);
  });
  serverOptions.forEach((option: any) => {
    optionNames.set(option[1], option[0]);
  });

  const [postObject, setPostObject] = React.useState({
    id: null,
    sureview_server: "",
    sureview_subject: "",
    sureview_cc: "",
    sureview_email: "",
  });

  const [selectedStreamNames, setSelectedStreamNames] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    if (sureViewAlerts[0]) {
      setPostObject({
        id: null,
        sureview_server: sureViewAlerts[0].sureview_server,
        sureview_subject: sureViewAlerts[0].sureview_subject,
        sureview_cc: sureViewAlerts[0].sureview_cc,
        sureview_email: sureViewAlerts[0].sureview_email,
      });
    }
  }, []);

  return (
    <Dialog
      open={addSureviewAlertDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Sureview Alert</DialogTitle>
      <DialogContent>
        {cameraStreams && cameraStreams.length > 1 && (
          <div>
            <FormLabel component="legend" sx={{ paddingBottom: 1 }}>
              {" "}
              Streams*
            </FormLabel>
            <Autocomplete
              multiple
              options={cameraStreams.map((object: any) => {
                return `${object.name} (${object.product})`;
              })}
              sx={{ width: 400 }}
              renderInput={(params) => <TextField {...params} />}
              onChange={(event, value) => {
                setSelectedStreamNames(value);
              }}
            />
            <br></br>
          </div>
        )}
        <div key="sureview_server">
          <Autocomplete
            disablePortal
            id="sureview_server"
            defaultValue={
              sureViewAlerts[0]
                ? optionNames.get(sureViewAlerts[0].sureview_server)
                : ""
            }
            options={serverOptions.map((option: string[]) => {
              return option[0];
            })}
            onChange={(event: any, newInputValue: any) => {
              setPostObject((previousState: any) => {
                return {
                  ...previousState,
                  sureview_server: optionsIds.get(newInputValue),
                };
              });
            }}
            sx={{ width: 350 }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Sureview Server"
                autoComplete="off"
                id="sureview_server"
                name="sureview_server"
              />
            )}
          />
        </div>
        <br></br>
        <TextField
          id="sureview_subject"
          variant="standard"
          label="Sureview Subject"
          defaultValue={
            sureViewAlerts[0] ? sureViewAlerts[0].sureview_subject : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sureview_subject: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="sureview_cc"
          variant="standard"
          label="Sureview cc"
          defaultValue={sureViewAlerts[0] ? sureViewAlerts[0].sureview_cc : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sureview_cc: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="sureview_email"
          variant="standard"
          label="Sureview Email"
          defaultValue={
            sureViewAlerts[0] ? sureViewAlerts[0].sureview_email : ""
          }
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sureview_email: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          helperText=""
          type="string"
        />
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddSureviewAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            const selectedStreamIndexs: number[] = [];

            const streamsObjectToPost = JSON.parse(
              JSON.stringify(cameraStreamsPatchObject)
            );

            if (cameraStreams && cameraStreams.length > 1) {
              selectedStreamNames.forEach((streamName: string) => {
                selectedStreamIndexs.push(streamNames.get(streamName));
              });

              selectedStreamIndexs.forEach((streamIndex: number) => {
                if (streamsObjectToPost[streamIndex]) {
                  streamsObjectToPost[streamIndex].sureview_alerts = [
                    ...streamsObjectToPost[streamIndex].sureview_alerts,
                    postObject,
                  ];
                }
              });
            }

            if (cameraStreams && cameraStreams.length === 1) {
              streamsObjectToPost[0].sureview_alerts.push(postObject);
            }

            setAddSureviewAlertDialogOpen(false);
            setBackdropLoadingScreenOn(true);
            handleSubmitNewSureviewAlert(
              cameraGeneralInfo,
              sureViewAlerts,
              streamsObjectToPost,
              navigate,
              setBackdropLoadingScreenOn,
              setCameraGeneralInfo,
              setCameraGeneralInfoBackup,
              setGeneralInfoChangesMade,
              setPatchObject,
              setSureviewAlerts,
              setActiveTab,
              setAddSureviewAlertDialogOpen,
              cameraGeneralInfoBackup,
              setIgnoreZonesBreadCrumbs,
              handleSitesBreadcrumbClick,
              handleSingularSiteBreadcrumbClick,
              immixAlerts,
              setAddImmixAlertDialogOpen,
              setSendingImmixTest,
              setImmixTestSuccessDialogOpen,
              setImmixTestFailDialogOpen,
              setDeleteImmixAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              immixAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera
            );
          }}
          text="Submit"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
